/**
 * Reads the `{ code, message }` shape the backend sends for structured errors (Ticket-348 and later),
 * without every call site re-implementing `error?.response?.data?.message`.
 */
type ApiErrorLike = { response?: { status?: number; data?: { code?: unknown; message?: unknown } }; message?: unknown };

const asApiError = (error: unknown): ApiErrorLike | null =>
	error && typeof error === "object" ? (error as ApiErrorLike) : null;

export const getApiErrorCode = (error: unknown): string | null => {
	const code = asApiError(error)?.response?.data?.code;
	return typeof code === "string" && code ? code : null;
};

export const getApiErrorMessage = (error: unknown, fallback: string): string => {
	const e = asApiError(error);
	const server = e?.response?.data?.message;
	if (typeof server === "string" && server) return server;
	if (typeof e?.message === "string" && e.message) return e.message;
	return fallback;
};

export const isApiErrorCode = (error: unknown, code: string, status?: number): boolean => {
	if (getApiErrorCode(error) !== code) return false;
	return status === undefined || asApiError(error)?.response?.status === status;
};
